export default "<toaster-container></toaster-container>\n\n<app-header></app-header>\n";